module.exports = __webpack_public_path__ + "static/media/homeAnimation.4d546794.gif";